import React from 'react';
import type { EdgeT, NodeT, SkeletonPreviewStyleT } from '../../../../types';
import { SKELETON_PREVIEW_STYLE } from '../constants';
type PropsT = {
  edges: EdgeT[];
  nodes: NodeT[];
  style: SkeletonPreviewStyleT;
};
export const PreviewEdges = ({
  edges,
  nodes,
  style
}: PropsT) => <>
    {edges.map(edge => {
    const startPoint = nodes.find(node => node.id === edge.startNode)?.point;
    const endPoint = nodes.find(node => node.id === edge.endNode)?.point;
    if (!startPoint || !endPoint) return null;
    return <line key={`preview-${edge.startNode}-${edge.endNode}`} x1={startPoint[0]} y1={startPoint[1]} x2={endPoint[0]} y2={endPoint[1]} stroke={style.strokeColor} style={{
      strokeWidth: style.strokeWidth
    }} opacity={SKELETON_PREVIEW_STYLE.EDGE_OPACITY} />;
  })}
  </>;